import { render } from "./BlogPosts.vue?vue&type=template&id=11933922"
import script from "./BlogPosts.vue?vue&type=script&lang=js"
export * from "./BlogPosts.vue?vue&type=script&lang=js"

import "./BlogPosts.vue?vue&type=style&index=0&id=11933922&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__